"use client";
import {
  useSelectList
} from "../__chunks/VZRFHU6Z.js";
import "../__chunks/J7DZFKDD.js";
import {
  useSelectProviderContext
} from "../__chunks/OFHTR2QK.js";
import "../__chunks/YRRYMVMY.js";
import "../__chunks/3IEDWLST.js";
import "../__chunks/RA2MZPUM.js";
import "../__chunks/J4JPXPLD.js";
import {
  usePopover
} from "../__chunks/BMYMDDP6.js";
import {
  createDialogComponent
} from "../__chunks/Z42C5PR3.js";
import "../__chunks/V3E5SLHB.js";
import "../__chunks/3TEK3C5Q.js";
import "../__chunks/4ZRXV5C7.js";
import "../__chunks/6O2UZOXH.js";
import "../__chunks/EMAID2BX.js";
import "../__chunks/6BRYOMMU.js";
import "../__chunks/OOBDFMJL.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/YNKDLCEK.js";
import "../__chunks/MKDDWKFK.js";
import "../__chunks/5QL6BP6J.js";
import "../__chunks/53CQGCDZ.js";
import "../__chunks/O4PHI74Y.js";
import "../__chunks/AH6A6OH6.js";
import "../__chunks/5M6RIVE2.js";
import "../__chunks/V4QWNWTM.js";
import "../__chunks/TYZXREX7.js";
import "../__chunks/AOQQTIBO.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/7AG4LN2H.js";
import "../__chunks/B2GB5ZIJ.js";
import "../__chunks/THGRQCVD.js";
import "../__chunks/UUT76IPH.js";
import "../__chunks/JS4W7WDG.js";
import "../__chunks/CGG6F755.js";
import "../__chunks/SWN3JYXT.js";
import "../__chunks/4YEPPC7Q.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/I6MSISV2.js";
import "../__chunks/QX2CMDZ5.js";
import "../__chunks/D6UA6CB7.js";
import "../__chunks/S67MTDSB.js";
import "../__chunks/FPBGCFAS.js";
import "../__chunks/KQWO6ME3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/select/select-popover.tsx
var TagName = "div";
var useSelectPopover = createHook(
  function useSelectPopover2(_a) {
    var _b = _a, { store, alwaysVisible } = _b, props = __objRest(_b, ["store", "alwaysVisible"]);
    const context = useSelectProviderContext();
    store = store || context;
    props = useSelectList(__spreadValues({ store, alwaysVisible }, props));
    props = usePopover(__spreadValues({ store, alwaysVisible }, props));
    return props;
  }
);
var SelectPopover = createDialogComponent(
  forwardRef(function SelectPopover2(props) {
    const htmlProps = useSelectPopover(props);
    return createElement(TagName, htmlProps);
  }),
  useSelectProviderContext
);
export {
  SelectPopover,
  useSelectPopover
};
